import * as api from "@/api/williams/scopesOfWork";
import { queryKeys } from "../../queryKeys";
import { ScopeOfWorkFilters } from "@/api/williams/scopesOfWork";
import { useInfiniteQuery } from "react-query";

const PAGE_SIZE = 100;

export function useScopeOfWorkList(filters: Partial<ScopeOfWorkFilters> = {}) {
  return useInfiniteQuery({
    queryKey: queryKeys.scopeOfWork.filter(filters),
    queryFn: ({ pageParam = 0 }) => {
      const skip = pageParam * PAGE_SIZE;
      return api.getScopeOfWorkList({ skip, take: PAGE_SIZE, ...filters });
    },
    getNextPageParam: (lastPage, allPages) => {
      if (lastPage.results.length === PAGE_SIZE) {
        return allPages.length;
      }
    },
  });
}
